module.exports = __webpack_public_path__ + "static/media/dots4.de9b4198.png";